
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M6.667 15.911C2.889 15.244 0 11.956 0 8c0-4.4 3.6-8 8-8s8 3.6 8 8c0 3.956-2.889 7.244-6.667 7.911l-.444-.355H7.11l-.444.355z","fill":"url(#paint0_linear)"}}),_c('path',{attrs:{"d":"M11.11 10.222L11.468 8H9.332V6.444c0-.622.222-1.11 1.2-1.11h1.022V3.288c-.577-.089-1.2-.178-1.777-.178-1.823 0-3.112 1.111-3.112 3.111V8h-2v2.222h2v5.645a6.783 6.783 0 002.667 0v-5.645h1.778z","fill":"#fff"}})]),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear","x1":"8","y1":"15.446","x2":"8","y2":"0","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#0062E0"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#19AFFF"}})]),_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    